export default class Base {
  constructor () {
    this._hasActiveApiRequest = false
  }

  /**
   * Get class name
   *
   * @returns {String}
   */
  name () {
    return this.constructor.name
  }

  /**
   * Mark class api request status as active
   *
   * @return {void}
   */
  startApiRequest () {
    this._hasActiveApiRequest = true
  }

  /**
   * Mark class api request status as inactive
   *
   * @return {void}
   */
  endApiRequest () {
    this._hasActiveApiRequest = false
  }

  hasActiveApiRequest () {
    return this._hasActiveApiRequest
  }
}
